import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  'mainEntity': faqItems.map((item) => ({
    '@type': 'Question',
    'name': item.question,
    'acceptedAnswer': {
      '@type': 'Answer',
      'text': item.answer,
    },
  })),
};

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-4xl mx-auto">
        {}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wider uppercase mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            Często zadawane pytania
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Odpowiedzi na najczęściej pojawiające się pytania dotyczące arkuszy Kakobuy.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqItems.map((faq, index) => (
            <div
              key={index}
              className="group rounded-xl bg-background-50 border border-background-200/60 hover:border-secondary-300 transition-all duration-300 overflow-hidden"
            >
              {}
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-start justify-between gap-4 text-left cursor-pointer"
              >
                <div className="flex items-start gap-3 min-w-0">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center mt-0.5">
                    <i className="ri-question-line text-secondary-600 text-sm"></i>
                  </span>
                  <h3 className="font-semibold text-foreground-900 text-sm md:text-base leading-snug pr-2">
                    {faq.question}
                  </h3>
                </div>
                <i className={`flex-shrink-0 ri-${openIndex === index ? 'subtract' : 'add'}-line text-foreground-400 text-lg transition-transform duration-200 mt-0.5`}></i>
              </button>

              {}
              <div
                className={`px-6 overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[500px] pb-5' : 'max-h-0'
                }`}
              >
                <div className="pl-11">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {}
        <div className="mt-10 text-center">
          <p className="text-foreground-500 text-sm mb-4">
            Masz więcej pytań? Sprawdź nasz kompletny przewodnik.
          </p>
          <Link
            to="/artykul/kakobuy-sheet-kompletny-przewodnik"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 cursor-pointer text-sm font-semibold whitespace-nowrap"
          >
            <i className="ri-book-open-line"></i>
            <span>Przeczytaj przewodnik</span>
          </Link>
        </div>
      </div>
    </section>
  );
}